<script>
import Masonry from 'masonry-layout';
import { createNamespacedHelpers } from 'vuex'
const { mapMutations, mapState } = createNamespacedHelpers('modal')

export default {
    name: 'NewsGrid',
    computed: {
         ...mapState({
            modalState: state => state.modalState
        }),
    },
    mounted() {
        this.itemsEl = this.$refs.items;
        this.msnry = new Masonry(this.itemsEl, {
            itemSelector: '.newsGrid__item',
            // columnWidth: 280,
            // gutter: 20,
            transitionDuration: 0,
            columnWidth: '.newsGrid__sizer',
            // initLayout: false,
            percentPosition: true,
        });
    },
    watch: {
        'modalState': function () {
            this.msnry.layout();
        }
    }
}
</script>
